import classes from "./FieldDataC.module.css";
import {  Route, Routes } from "react-router-dom";

// import { useLocation } from "react-router-dom";



import Dashboard from "../Dashboard/Dashboard";
import User from "../User/UserDetails";
import NewUser from "../User/UserNew"
import UserView from "../User/UserView";
import AllUsers from "../Dashboard/AllUsers";
import AllSites from "../Dashboard/AllSites";
import ModulesRights from "../Dashboard/ModulesRights";
import NewRights from "../UserRights/NewRights";
import EmployeeDetails from "../EmployeeDetails/EmployeeDetails";
import EmployeeNew from "../EmployeeDetails/EmployeeNew";
import EmployeeView from "../EmployeeDetails/EmployeeView";
import Unit from "../CityMaster/city"


const FieldDataS = (fieldProps) => {
  // const location = useLocation();

  // console.log("Current path:", location.pathname);
  return (
    <div className={classes["Fields"]}>
      <Routes>
       <Route path="/dashboard" element={<Dashboard />} />
         <Route path="/all-users" element={<AllUsers />} />
         <Route path="/all-sites" element={<AllSites />} />
         <Route path="/modules-rights" element={<ModulesRights />} />
        <Route path="/users" element={<User/>}/>
        <Route path="/users/create" element={<NewUser/>}/>
        <Route path="/users/view/:id" element={<UserView/>}/>
        <Route path="/users/rights" element={<NewRights/>}/>
        <Route path="/users/unit" element={<Unit/>}/>
        <Route path="/employee/emp-detail" element={<EmployeeDetails/>}/>
        <Route path="/transection/employee-create" element={<EmployeeNew/>}/>
        <Route path="/transaction/employee-details-view/:id" element={<EmployeeView/>}/>
      </Routes>
    </div>
  );
};

export default FieldDataS;
